import React from 'react';
import { cn } from '@/lib/utils';

export type InstructionsSpanTypographyProps = React.HTMLAttributes<HTMLSpanElement> & {
    className?: string;
};

function InstructionsSpanTypography({ className, ...props }: InstructionsSpanTypographyProps): React.JSX.Element {
    return <span className={cn('text-foreground text-sm', className)} {...props} />;
}

export default InstructionsSpanTypography;
